import { useRouter } from 'next/router'
import { useEffect } from 'react';

export default function NetzwerkIndex({}) {
    const router = useRouter();

    useEffect(() => {
        router.push("/netzwerk/ueber-uns");
    }, []);

    return (
        <></>
    )
}
